import routeHelper from "helpers/route"

export default routeHelper.lazyLoadRoute(
  () => import("containers/PageChannelReplay/PageChannelReplay"),
  "containers/PageChannelReplay/PageChannelReplay"
)
